import { create } from 'zustand';
import type { ComponentType } from 'react';

/**
 * Allows any page to inject a component into the MainLayout header.
 * The component fills the top header bar's per-page controls slot.
 * Set on page mount, clear on unmount.
 *
 * Usage in a page:
 *   const setSlot = useHeaderSlotStore(s => s.setSlot);
 *   useEffect(() => { setSlot(MyHeaderControls); return () => setSlot(null); }, [setSlot]);
 */
interface HeaderSlotState {
  SlotComponent: ComponentType | null;
  setSlot: (component: ComponentType | null) => void;
}

export const useHeaderSlotStore = create<HeaderSlotState>((set) => ({
  SlotComponent: null,
  setSlot: (SlotComponent) => set({ SlotComponent }),
}));
